module.exports = __webpack_public_path__ + "static/media/crow_roti_taking_from_river02.2e1384ff.png";